<template>
  <div class="hold-hold-transition">
    <div class="wrapper">
      <div class="content-wrapper">
        <!-- Encabezados -->
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <!-- titulo -->
              <div class="col-sm-6">
                <h5 class="mb-0">Calificacion</h5>
              </div>
              <!-- /.titulo -->
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Operacion</li>
                  <li class="breadcrumb-item active">Procesos</li>
                  <li class="breadcrumb-item active">Calificaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <!-- CUERPO SECTION GENERAL -->
        <section class="content">
          <div class="container-fluid">
            <div class="card shadow-sm">
              <div class="card-header pt-2 pb-2">
                <div class="col-3 pt-2 pb-2">
                  <h5 class="mb-0">Calificaciones</h5>
                </div>
              </div>
              <div class="card-body">
                <!-- 
            |------------------------------------------
            |CREACION O EDICION CALIFICACION
            |------------------------------------------
                -->
                <div class="row">
                  <!-- Campo Nombre form -->
                  <div class="col-md-3 col-sm-12">
                    <div class="form-group">
                      <label for="nombre">Nombre</label>
                      <input
                        :disabled="definitivo == 1"
                        type="text"
                        class="form-control form-control-sm"
                        id="razon_social"
                        v-model="form.nombre"
                        :class="
                          $v.form.nombre.$invalid ? 'is-invalid' : 'is-valid'
                        "
                      />
                    </div>
                  </div>
                  <!-- /.Campo Nombre form -->
                  <!-- Campo fecha inicial form -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="estado">Fecha Inicial</label>
                      <input
                        :disabled="definitivo == 1"
                        type="date"
                        class="form-control form-control-sm"
                        id="fecha_inicial"
                        v-model="form.fecha_inicial"
                        :class="
                          $v.form.fecha_inicial.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                      />
                    </div>
                  </div>
                  <!-- /. Campo fecha inicial form -->
                  <!-- Campo fecha final form -->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="estado">Fecha Final</label>
                      <input
                        :disabled="definitivo == 1"
                        type="date"
                        class="form-control form-control-sm"
                        id="fecha_final"
                        v-model="form.fecha_final"
                        :class="
                          $v.form.fecha_final.$invalid
                            ? 'is-invalid'
                            : 'is-valid'
                        "
                      />
                    </div>
                  </div>
                  <!-- /. Campo fecha final form -->
                  <!-- Campo linea de negocio-->
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="linea_negocio">Estado</label>
                      <select
                        :disabled="definitivo == 1"
                        class="form-control form-control-sm"
                        v-model="form.estado"
                        :class="
                          $v.form.estado.$invalid ? 'is-invalid' : 'is-valid'
                        "
                      >
                        <option value="">Seleccione...</option>
                        <option
                          v-for="estado in listasForms.estados"
                          :key="estado.id"
                          :value="estado.numeracion"
                        >
                          {{ estado.descripcion }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
                <!-- 
            |--------------------------------------------------------
            |AGREGAR ITEMS DE CALIFICACION CON SU RESPECTIVA PESO %
            |--------------------------------------------------------
                -->
                <div class="row" v-if="form.id">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <div class="accordion" id="accordionExample">
                      <PorcentajesGeneral
                        :form="form"
                        :definitivo="definitivo"
                        :porcentajes_calificacion="porcentajes_calificacion"
                        :val_total_porcentaje="val_total_porcentaje"
                        :listas-forms="listasForms"
                      />
                    </div>
                  </div>
                </div>

                <!-- 
            |------------------------------------------
            |ASOCIACION EMPRESAS
            |------------------------------------------
                -->
                <div
                  class="row"
                  v-if="form.estado_porcentaje_calificacion == 2"
                >
                  <div class="col-lg-12 col-md-6 col-sm-12">
                    <EmpresasAsociadas
                      :form="form"
                      :definitivo="definitivo"
                      :porcentajes-empresa="porcentajesEmpresa"
                    />
                  </div>
                </div>
              </div>
              <!-- foot of the card -->
              <div class="card-footer">
                <div class="row">
                  <button
                    :disabled="definitivo == 1"
                    class="btn bg-primary col-md-1"
                    v-show="!$v.form.$invalid"
                    @click="save_calificacion()"
                  >
                    <i class="fas fa-paper-plane"></i><br />Guardar
                  </button>

                  <button class="btn bg-secondary col-md-1" @click="back()">
                    <i class="fas fa-reply"></i><br />Volver
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- modal asociar empresas -->
          <div class="modal fade" id="modal_empresas">
            <div class="modal-dialog modal-md">
              <div class="modal-content">
                <div class="modal-header bg-geogo-top-left pt-2 pb-2">
                  <h4 class="modal-title text-white">Agregar Empresa</h4>
                  <button
                    type="button"
                    class="close text-white"
                    data-dismiss="modal"
                    id="close-modal"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <!-- Cuerpo del modal -->
                <div class="modal-body">
                  <div class="row">
                    <!-- campo Nombre -->
                    <div class="col-lg-12">
                      <div class="form-group">
                        <label for="descripcion">Empresa</label>
                        <v-select
                          :options="listasForms.empresas"
                          label="razon_social"
                          :reduce="(e) => e.id"
                          v-model="form_empresa.empresa_id"
                          :class="
                            !form_empresa.empresa_id
                              ? 'border-danger'
                              : 'border-success'
                          "
                          class="shadow-sm border rounded"
                        />
                      </div>
                    </div>
                    <div
                      class="col-lg-12"
                      v-if="
                        form_empresa.empresa_id &&
                        porcentajes_calificacion.length > 0
                      "
                    >
                      <div
                        v-for="item in porcentajes_calificacion"
                        :key="item.id"
                      >
                        <label>{{ item.nombre }} % {{ item.porcentaje }}</label>
                        <input
                          type="number"
                          class="form-control form-control-sm"
                          :class="
                            porcentajes_calificacion_empresa[item.id] &&
                            (Number(
                              porcentajes_calificacion_empresa[item.id]
                                .porcentaje
                            ) < 0 ||
                              Number(
                                porcentajes_calificacion_empresa[item.id]
                                  .porcentaje
                              ) > 100)
                              ? 'is-invalid'
                              : porcentajes_calificacion_empresa[item.id] &&
                                porcentajes_calificacion_empresa[item.id]
                                  .porcentaje !== null &&
                                porcentajes_calificacion_empresa[item.id]
                                  .porcentaje !== ''
                              ? 'is-valid'
                              : ''
                          "
                          v-model.number="
                            porcentajes_calificacion_empresa[item.id].porcentaje
                          "
                          min="0"
                          max="100"
                          step="0.01"
                        />
                      </div>
                    </div>
                    <!-- /. campo Nombre -->
                  </div>
                </div>
                <div class="modal-footer justify-content-between">
                  <button
                    type="button"
                    class="btn btn-primary shadow-sm"
                    v-if="
                      form_empresa.empresa_id &&
                      !Object.values(porcentajes_calificacion_empresa).some(
                        (item) => item.porcentaje < 0 || item.porcentaje > 100
                      )
                    "
                    v-on:click="agregarEmpresa()"
                  >
                    Guardar
                  </button>
                </div>
              </div>
              <!-- /.modal-content -->
            </div>
            <!-- /.modal-dialog -->
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
/* axios */
import axios from "axios";
import vSelect from "vue-select";
import PorcentajesGeneral from "./PorcentajesGeneral.vue";
import EmpresasAsociadas from "./EmpresasAsociadas.vue";
import "vue-select/dist/vue-select.css";

const $ = window.$;
/* validaciones */
import { required, maxlength } from "vuelidate/lib/validators";
export default {
  name: "CalificacionDetalleForm",
  components: {
    vSelect,
    PorcentajesGeneral,
    EmpresasAsociadas,
  },
  data() {
    return {
      porcentajesEmpresa: [],
      accion: "",
      metodo: "POST",
      definitivo: 0,
      form: {},
      porcentajes_calificacion_empresa: {},
      porcentajes_calificacion: [],
      val_total_porcentaje: 0,
      form_empresa: {
        empresa_id: null,
        accion: null,
        id_calificacion: null,
      },
      numero_empresas: 0,
      listasForms: {
        estados: [],
        itemsEvaluacion: [],
        empresas: [],
      },
    };
  },
  validations: {
    form: {
      nombre: {
        required,
      },
      fecha_inicial: {
        required,
      },
      fecha_final: {
        required,
      },
      estado: {
        required,
      },
    },
  },
  methods: {
    init() {
      this.form.id = this.form.id ? this.form.id : this.$route.params.id;
      this.accion = this.metodo == "PUT" ? "Editar" : this.$route.params.accion;
      if (this.accion == "Editar") {
        this.metodo = "PUT";
        axios
          .get(`/api/hidrocarburos/calificaciones/show/${this.form.id}`)
          .then((response) => {
            this.form = response.data.calificacion;
            this.porcentajes_calificacion = response.data.porcentajes
              ? response.data.porcentajes
              : [];

            //inicializar el porcentaje de cada item de calificacion
            this.porcentajes_calificacion.forEach((item) => {
              this.porcentajes_calificacion_empresa[item.id] = {
                porcentaje: null,
              };
            });

            this.porcentajesEmpresa = response.data.porcentajesEmpresa
              ? response.data.porcentajesEmpresa
              : [];
            this.numero_empresas = response.data.porcentajesEmpresa
              ? response.data.porcentajesEmpresa.length
              : 0;
            if (this.form && this.form.estado == 2) {
              this.definitivo = 1;
            }
            this.val_total_porcentaje = 0;
            this.val_total_porcentaje = this.porcentajes_calificacion.reduce(
              (sum, p) => {
                const porcentaje = Number(p.porcentaje) || 0;
                return sum + porcentaje;
              },
              0
            );
          });
      } else {
        this.metodo = "POST";
      }

      if (this.form.estado == 2) {
        this.definitivo = 1;
      }
    },

    save_calificacion() {
      if (!this.$v.form.$invalid) {
        if (this.form.fecha_inicial > this.form.fecha_final) {
          this.$swal({
            icon: "error",
            title: "La fecha inicial no puede ser mayor a la fecha final",
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        } else {
          axios({
            method: this.metodo,
            url: "/api/hidrocarburos/calificaciones",
            data: this.form,
          })
            .then((response) => {
              this.metodo = "PUT";
              this.form.id = response.data.calificacion.id;
              this.init();
              //se valida si la calificacion no esta duplicada
              if (response.data.estado == 1) {
                this.$swal({
                  icon: "error",
                  title:
                    "ya existe una calificacion para la fechas definidas...",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
              } else {
                this.$swal({
                  icon: "success",
                  title: "la calificacion se guardo exitosamente...",
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 3000,
                  timerProgressBar: true,
                });
                if (this.form.estado == 2) {
                  this.definitivo = 1;
                }
              }
            })
            .catch((e) => {
              this.$swal({
                icon: "error",
                title: "Ocurrio un error, vuelva a intentarlo..." + e,
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            });
        }
      }
    },

    agregarEmpresa() {
      if (this.form_empresa.empresa_id) {
        //se agrega al arreglo el id de la calificacion
        this.form_empresa.accion = 1;
        this.form_empresa.id_calificacion = this.form.id;
        let data = this.form_empresa;
        data.porcentajes = this.porcentajes_calificacion_empresa;

        axios({
          method: "PUT",
          url: "/api/hidrocarburos/calificaciones/empresa",
          data: data,
        })
          .then((response) => {
            if (response.data == 2) {
              this.$swal({
                icon: "error",
                title: "la empresa ya se encuentra asignada",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
            } else if (response.data == 1) {
              this.$swal({
                icon: "success",
                title: "la empresa se guardo exitosamente...",
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
              });
              this.init();
              // Cerrar modal y limpiar campos
              $("#modal_empresas").modal("hide");
            }
          })
          .catch((e) => {
            this.$swal({
              icon: "error",
              title:
                "Ocurrio un error, Comuniquese con el administrador del sistema..." +
                e,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      } else {
        this.$swal({
          icon: "error",
          title: "Debe seleccionar una empresa",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          timerProgressBar: true,
        });
      }
    },

    limpiarModalEmpresas() {
      this.form_empresa.empresa_id = null;
      //inicializar el porcentaje de cada item de calificacion
      this.porcentajes_calificacion.forEach((item) => {
        this.porcentajes_calificacion_empresa[item.id] = {
          porcentaje: null,
        };
      });
    },

    getEstados() {
      axios.get("/api/lista/28").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    getItemsCalificacion() {
      axios.get("/api/lista/33").then((response) => {
        this.listasForms.itemsEvaluacion = response.data;
      });
    },

    getEmpresas() {
      axios
        .get("/api/admin/empresas/lista")
        .then((response) => {
          // Obtenemos los datos
          let self = this;
          self.listasForms.empresas = response.data;
        })
        .catch((e) => {
          // Capturamos los errores
          this.$swal({
            icon: "error",
            title: "Ocurrio un error" + e,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
          });
        });
    },

    back() {
      return this.$router.replace({ path: "/Hidrocarburos/Calificaciones" });
    },
  },
  mounted() {
    this.init();
    this.getEstados();
    this.getItemsCalificacion();
    this.getEmpresas();
  },
};
</script>
